module.exports = __webpack_public_path__ + "img/fyt_p25.770bdf46.png";